import { render, staticRenderFns } from "./FieldPermissionUpdate.vue?vue&type=template&id=7cdd0542&scoped=true"
import script from "./FieldPermissionUpdate.vue?vue&type=script&lang=js"
export * from "./FieldPermissionUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdd0542",
  null
  
)

export default component.exports